import { Component, Input } from '@angular/core';

import { NavigationState } from '../../enums/navigation-state.enum';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SideBarComponent {
  @Input() user!: string;
  @Input() clientName?: string;
  @Input() state!: NavigationState;

  showTodoSection = false;

  toggleTodo() {
    console.log('toggleTodo', this.showTodoSection);
    this.showTodoSection = !this.showTodoSection;
  }
}
